import { Button, Accordion } from "web/components"

import useUpcomingAndOverdueTasks from "../hooks/useUpcomingAndOverdueTasks"
import { Task } from "web/components"

export default function UpcomingAndOverdueTasks({ isOpen, onToggle }) {
  const { overdueTaskCount, tasks, workflow } = useUpcomingAndOverdueTasks()

  const hasTasks = tasks.length > 0

  function goToTask() {
    window.Turbo.visit(`${window.location.pathname}/workflow`)
  }

  const hasAdditionalTasks = tasks.length > 5
  const numberOfAdditionalTasks = tasks.length - 5

  return (
    <Accordion
      title="Upcoming and Overdue"
      isOpen={isOpen}
      onToggle={onToggle}
      notificationCount={overdueTaskCount}
    >
      <div>
        {hasTasks && (
          <div className="mb-3">
            {tasks.slice(0, 5).map((task) => (
              <Task key={task.id} workflow={workflow} task={task} />
            ))}
          </div>
        )}
        {!hasTasks && (
          <div className="grid place-items-center py-2 text-sm italic text-neutral-4">
            No tasks to display.
          </div>
        )}
        <div className="mt-4 flex items-center justify-between">
          <span className="text-sm text-neutral-4">
            {hasAdditionalTasks && `And ${numberOfAdditionalTasks} more...`}
          </span>
          <Button variant="secondary_default" size="small" onClick={goToTask}>
            All Tasks
          </Button>
        </div>
      </div>
    </Accordion>
  )
}
